// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DocumentsV1GeneratePdfFromTemplateSaveSaveResponse {
    static getAttributeTypeMap() {
        return DocumentsV1GeneratePdfFromTemplateSaveSaveResponse.attributeTypeMap;
    }
}
DocumentsV1GeneratePdfFromTemplateSaveSaveResponse.discriminator = undefined;
DocumentsV1GeneratePdfFromTemplateSaveSaveResponse.additionalProperties = false;
DocumentsV1GeneratePdfFromTemplateSaveSaveResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=documentsV1GeneratePdfFromTemplateSaveSaveResponse.js.map